import React from "react";
import CIcon from "@coreui/icons-react";
import moment from "moment";
import Loading from "src/helpers/commons/loader";

class VisitorsReportData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortKey: "order_no",
      sortAsc: false,
    };
  }

  applySort(key, asc, dec) {
    this.setState({ sortKey: key, sortAsc: asc }, () => {
      const updatedData = this.props.data.sort((a, b) =>
        (dec ? +a[key] > +b[key] : a[key] > b[key])
          ? asc
            ? 1
            : -1
          : !asc
          ? 1
          : -1
      );
      this.props.onUpdate(updatedData);
    });
  }
  getDuration(check_in, check_out) {
    let totalTime = "";
    if(check_out!=null){

        //convert the time in moment readable form
        const startTime = moment(check_in, "HH:mm:ss a");
        const endTime = moment(check_out, "HH:mm:ss a");

        //calculate the duration and difference between the two times
        const duration = moment.duration(endTime.diff(startTime));

        //duration in hours
        const hours = parseInt(duration.asHours());

        // duration in minutes
        const minutes = parseInt(duration.asMinutes()) % 60;


        if (hours > 0) {
          totalTime += hours + " hour and " + minutes + " min";
        } else {
          totalTime += minutes + " min";
        }
    }
    else {
        totalTime='-';
    }
    return totalTime;
  }

  render() {
    const { sortKey, sortAsc } = this.state;
    const { data, isLoading } = this.props;

    return (
      <React.Fragment>
        {data.length > 0 ? (

                <table className="table table-bordered data-table">
                  <thead>
                    <tr>
                      <th style={{ width: "2%" }}>S#</th>
                      <th
                        style={{
                          width: "6%",
                          textAlign: "left",
                          cursor: "pointer",
                        }}
                        onClick={() => this.applySort("name", !sortAsc)}
                      >
                        Visitor Name{" "}
                        {"name" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                      <th
                        style={{
                          width: "12%",
                          textAlign: "left",
                          cursor: "pointer",
                        }}
                        onClick={() => this.applySort("cnic", !sortAsc)}
                      >
                        CNIC{" "}
                        {"cnic" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                      <th
                        style={{
                          width: "12%",
                          textAlign: "left",
                          cursor: "pointer",
                        }}
                        onClick={() => this.applySort("firm", !sortAsc)}
                      >
                        Firm{" "}
                        {"firm" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                      <th
                        style={{
                          width: "6%",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => this.applySort("phone", !sortAsc)}
                      >
                        Phone{" "}
                        {"phone" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                      <th
                        style={{
                          width: "6%",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.applySort("employee_name", !sortAsc)
                        }
                      >
                        Employee Visited{" "}
                        {"employee_name" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                      <th
                        style={{
                          width: "8%",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => this.applySort("designation", !sortAsc)}
                      >
                        Designation{" "}
                        {"designation" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                      <th
                        style={{
                          width: "10%",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => this.applySort("check_in", !sortAsc)}
                      >
                        Check IN{" "}
                        {"check_in" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                      <th
                        style={{
                          width: "10%",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => this.applySort("check_out", !sortAsc)}
                      >
                        Check OUT{" "}
                        {"check_out" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                      <th
                        style={{
                          width: "10%",
                          textAlign: "center",
                          cursor: "pointer",
                        }}
                        onClick={() => this.applySort("duration", !sortAsc)}
                      >
                        Duration{" "}
                        {"duration" === sortKey && (
                          <React.Fragment>
                            {sortAsc ? (
                              <CIcon name="cilChevronTop" />
                            ) : (
                              <CIcon name="cilChevronBottom" />
                            )}
                          </React.Fragment>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((row, dex) => (
                      <tr key={"row-" + dex}>
                        <td>{dex + 1}</td>
                        <td style={{ textAlign: "left" }}>{row.name}</td>
                        <td style={{ textAlign: "left" }}>{row.cnic}</td>
                        <td style={{ textAlign: "left" }}>{row.firm.name}</td>
                        <td style={{ textAlign: "center" }}>{row.phone}</td>
                        <td style={{ textAlign: "center" }}>
                          {row.employee.name}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {row.employee.designation.name}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {row.check_in_date + " " + row.check_in}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {(row.check_out_date && row.check_out) ? row.check_out_date + " " + row.check_out: '-'}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          {this.getDuration(row.check_in,row.check_out)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              
        ) : (
          <div style={{ textAlign: "center" }}>
            {isLoading ? Loading : "No record to show..."}
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default VisitorsReportData;
